import { Point } from 'pixi.js-legacy';
import Key from '../input/key';
import { DragManager } from './dragManager';
import { SelectRectangle } from './selectRectangle';
export class SelectOptions {
    constructor() {
        this.buttonMode = true;
        this.select = () => { };
        this.deselect = () => { };
    }
}
export class SelectManager {
    constructor() {
        this.allowSelect = true;
        this.selectables = [];
        this.selectRectangle = new SelectRectangle();
        this.setupKeyboard();
    }
    static getInstance() {
        if (!this._instance) {
            this._instance = new SelectManager();
        }
        return this._instance;
    }
    destroy() {
        this.shiftKey.destroy();
        SelectManager._instance = undefined;
    }
    setContainer(container) {
        this.stage = container;
        this.stage.interactive = true;
        this.stage
            .on('mousedown', this.stageSelect.bind(this))
            .on('mouseup', this.stageDeselect.bind(this))
            .on('mouseupoutside', this.stageDeselect.bind(this))
            .on('mousemove', this.stageDragUpdate.bind(this));
    }
    setupKeyboard() {
        this.isShiftDown = false;
        this.shiftKey = new Key('Shift');
        this.shiftKey.press = () => {
            this.isShiftDown = true;
        };
        this.shiftKey.release = () => {
            this.isShiftDown = false;
        };
    }
    addSelectable(obj, options) {
        if (!this.allowSelect) {
            return;
        }
        if (options == null) {
            options = new SelectOptions();
        }
        obj.interactive = true;
        obj.buttonMode = options.buttonMode;
        obj.selectedTexture = options.selectedTexture;
        obj.selectCallback = options.select;
        obj.deselectCallback = options.deselect;
        obj
            .on('mousedown', this.onSelect.bind(this))
            .on('touchstart', this.onSelect.bind(this));
        this.selectables.push(obj);
    }
    stageSelect(event) {
        if (!this.allowSelect) {
            return;
        }
        if (this.isShiftDown) {
            DragManager.getInstance().stopAllDragging();
            this.selectOrigin = event.data.getLocalPosition(this.stage);
            this.stage.addChild(this.selectRectangle);
        }
    }
    stageDeselect() {
        if (this.isShiftDown) {
            this.selectOrigin = null;
            this.stage.removeChild(this.selectRectangle);
            this.selectRectangle = new SelectRectangle();
        }
    }
    stageDragUpdate(event) {
        if (this.isShiftDown && this.selectOrigin != null) {
            const actualPos = new Point(this.selectOrigin.x, this.selectOrigin.y);
            const newPos = event.data.getLocalPosition(this.stage);
            const w = newPos.x - actualPos.x;
            const h = newPos.y - actualPos.y;
            if (newPos.x > this.selectOrigin.x) {
                if (newPos.y < this.selectOrigin.y) {
                    actualPos.y = newPos.y;
                }
            }
            if (newPos.x < this.selectOrigin.x) {
                actualPos.x = newPos.x;
                if (newPos.y < this.selectOrigin.y) {
                    actualPos.y = newPos.y;
                }
            }
            this.selectRectangle.draw(this.selectOrigin, w, h, actualPos);
            for (const obj of this.selectables) {
                if (this.selectRectangle.contains(obj)) {
                    if (!obj.selected) {
                        this.select(obj);
                    }
                }
                else {
                    if (obj.selected) {
                        this.deselect(obj);
                    }
                }
            }
        }
    }
    onSelect(event) {
        if (this.isShiftDown) {
            return;
        }
        if (event.target.selected) {
            this.deselect(event.target);
        }
        else {
            this.select(event.target);
        }
    }
    select(target) {
        target.selected = true;
        target.selectCallback();
        this.globalSelectCallback(target);
    }
    deselect(target, shouldCallback = true) {
        target.selected = false;
        target.deselectCallback();
        if (shouldCallback) {
            this.globalDeselectCallback(target);
        }
    }
}
